import typographyStyles from '@cof/fs-typography-core/lib/typography.lit.js';
import { html, LitElement } from 'lit';
import { DebugService } from '../../../../shared/services/debug.service.js';

class EligibilityLinkComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepName');
  }

  static styles = [typographyStyles];

  render() {
    return html`<a
      href="#"
      class="fs-link fs-link--primary"
      @click="${this.scrollToVehicleDisclosures}"
    >
      <slot></slot>
    </a> `;
  }

  scrollToVehicleDisclosures(ev) {
    ev.preventDefault();
    this.debug.log('scrollToVehicleDisclosures');
    let scrollYPos;
    const footer = document.querySelector('refi-footer');
    if (!footer) {
      return false;
    }

    const disclosures =
      footer.shadowRoot.querySelector('refi-disclosures').shadowRoot;
    const progressbar = document.querySelector('.progress-bar') || {
      clientHeight: 0,
    };
    const commonheader = document.querySelector('refi-header');

    if (
      !disclosures
        .querySelector('.disclosures-content')
        .classList.contains('open')
    ) {
      const openDisclosures = disclosures.querySelector('a');
      openDisclosures.click();
    }

    // TODO: needs to be after click event
    setTimeout(() => {
      scrollYPos =
        disclosures
          .querySelector('refi-chariot')
          .shadowRoot.querySelector('h6:nth-child(4)')
          .getBoundingClientRect().top +
        window.scrollY -
        (progressbar.clientHeight + commonheader.clientHeight);
      window.scrollTo(0, scrollYPos);
    }, 25);

    return false;
  }
}

customElements.define('eligibility-link', EligibilityLinkComponent);
